var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5854 2.56877C13.4433 2.84364 14 3.64516 14 4.52144V7.41511C14 10.5144 12.1241 13.3118 9.25682 14.4142L8.48876 14.7095C8.48875 14.7095 8.48877 14.7095 8.48876 14.7095C8.17415 14.8304 7.82599 14.8305 7.51129 14.7095C7.51128 14.7095 7.5113 14.7095 7.51129 14.7095L6.7432 14.4142C3.87595 13.3118 2 10.5144 2 7.41511V4.52141C2 3.64508 2.55679 2.8436 3.41462 2.56877C3.41461 2.56877 3.41463 2.56877 3.41462 2.56877L7.38704 1.29604C7.7859 1.16825 8.21415 1.16825 8.61301 1.29604L12.5854 2.56877ZM3.78075 3.71155C3.43525 3.82224 3.2 4.15029 3.2 4.52141V7.41511C3.2 10.0324 4.78354 12.3751 7.1738 13.2941L7.94188 13.5894C7.97935 13.6038 8.02065 13.6038 8.05813 13.5894L8.82619 13.2941C11.2165 12.3751 12.8 10.0324 12.8 7.41511V4.52144C12.8 4.1503 12.5648 3.82224 12.2193 3.71155L8.24688 2.43882C8.08614 2.38732 7.91391 2.38732 7.75318 2.43882L3.78075 3.71155Z",
    fill: "#009469"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49327 6.57504C9.72758 6.34072 10.1075 6.34072 10.3418 6.57504C10.5548 6.78805 10.5742 7.12138 10.3999 7.35627L10.3418 7.42356L7.82339 9.94196C7.61038 10.155 7.27705 10.1743 7.04216 10.0001L6.97487 9.94196L5.78367 8.75076C5.54935 8.51645 5.54935 8.13655 5.78367 7.90224C5.99668 7.68922 6.33001 7.66986 6.5649 7.84414L6.63219 7.90224L7.39913 8.6689L9.49327 6.57504Z",
    fill: "#009469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.298b38574089bdffbe3b6671cae780c1.svg";
export { ForwardRef as ReactComponent };